export const environment = {
  production: false,
  domain: 'https://sonapi.gxstaging.net/api',
  paystackKey: 'pk_test_c9d44b692369902044962ac32fcd253d3eeaafef',
  port: 5000,
  remitaInlineUrl:
    'https://demo.remita.net/payment/v1/remita-pay-inline.bundle.js',
};
